import React from 'react';
import PropTypes from 'prop-types';
import { MoreVertical } from '@/lib/icons';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

export default function ActionMenu({ menuOptions, onSelect }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8 p-0" data-action-menu>
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {menuOptions.map((option) => (
          <DropdownMenuItem
            key={option.action}
            className={option.destructive ? 'text-destructive' : ''}
            onSelect={(e) => {
              if (e) e.preventDefault();
              setTimeout(() => {
                onSelect(option.action);
              }, 0);
            }}
          >
            {option.icon && (
              <span className={`mr-2 h-4 w-4 ${option.destructive ? 'text-destructive' : ''}`}>
                {option.icon}
              </span>
            )}
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

ActionMenu.propTypes = {
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      action: PropTypes.string.isRequired,
      destructive: PropTypes.bool,
      icon: PropTypes.node,
    })
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
}; 